var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaypal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 21,
    viewBox: "0 0 82 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2326_501)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.474 8.89223C63.2283 10.5058 61.996 10.5058 60.8041 10.5058H60.1259L60.6016 7.49324C60.6303 7.31122 60.7873 7.17708 60.9717 7.17708H61.2827C62.0938 7.17708 62.8602 7.17708 63.2554 7.63931C63.4917 7.91587 63.5633 8.32577 63.474 8.89223ZM62.9552 4.68274H58.46C58.1528 4.68274 57.8911 4.90638 57.8433 5.21001L56.0257 16.7359C55.9897 16.9631 56.1655 17.1688 56.3958 17.1688H58.702C58.9172 17.1688 59.1004 17.0122 59.1338 16.7997L59.6493 13.5322C59.6972 13.2286 59.9588 13.005 60.2661 13.005H61.6885C64.6493 13.005 66.358 11.572 66.8047 8.73223C67.0057 7.49021 66.8127 6.51425 66.2311 5.83102C65.5919 5.07991 64.459 4.68274 62.9552 4.68274Z",
    fill: "#2790C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.414 8.89223C31.1683 10.5058 29.936 10.5058 28.7443 10.5058H28.0661L28.5417 7.49324C28.5705 7.31122 28.7275 7.17708 28.9118 7.17708H29.2227C30.034 7.17708 30.8004 7.17708 31.1954 7.63931C31.432 7.91587 31.5035 8.32577 31.414 8.89223ZM30.8954 4.68274H26.4002C26.093 4.68274 25.8313 4.90638 25.7835 5.21001L23.9657 16.7359C23.9299 16.9631 24.1057 17.1688 24.3358 17.1688H26.4821C26.7893 17.1688 27.0511 16.9452 27.099 16.6417L27.5895 13.5322C27.6372 13.2286 27.899 13.005 28.2063 13.005H29.6287C32.5893 13.005 34.2982 11.572 34.7449 8.73223C34.9459 7.49021 34.753 6.51425 34.1713 5.83102C33.532 5.07991 32.399 4.68274 30.8954 4.68274Z",
    fill: "#27346A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3308 13.0301C41.1229 14.26 40.1465 15.0857 38.9013 15.0857C38.277 15.0857 37.7772 14.8849 37.456 14.5046C37.1376 14.1277 37.0178 13.5907 37.1186 12.9927C37.3126 11.7739 38.3045 10.9216 39.5308 10.9216C40.1421 10.9216 40.6382 11.1244 40.9659 11.5081C41.2956 11.8945 41.4251 12.4352 41.3308 13.0301ZM44.3304 8.84081H42.178C41.9936 8.84081 41.8366 8.97475 41.8079 9.15717L41.7132 9.75899L41.5627 9.54081C41.0966 8.86424 40.0578 8.63818 39.0205 8.63818C36.6425 8.63818 34.6112 10.4402 34.2158 12.9677C34.01 14.2285 34.3021 15.4333 35.017 16.2743C35.6738 17.0471 36.6112 17.3687 37.7279 17.3687C39.6447 17.3687 40.7077 16.1374 40.7077 16.1374L40.6116 16.7356C40.5756 16.963 40.7514 17.1689 40.9817 17.1689H42.9201C43.2273 17.1689 43.4889 16.9455 43.5368 16.6418L44.7005 9.27374C44.7364 9.04626 44.5607 8.84081 44.3304 8.84081Z",
    fill: "#27346A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3905 13.0301C73.1827 14.26 72.2065 15.0857 70.9612 15.0857C70.3368 15.0857 69.8372 14.8849 69.5158 14.5046C69.1974 14.1277 69.0776 13.5907 69.1786 12.9927C69.3724 11.7739 70.3643 10.9216 71.5907 10.9216C72.2019 10.9216 72.6982 11.1244 73.0257 11.5081C73.3554 11.8945 73.4849 12.4352 73.3905 13.0301ZM76.3901 8.84081H74.2378C74.0534 8.84081 73.8964 8.97475 73.8677 9.15717L73.773 9.75899L73.6227 9.54081C73.1564 8.86424 72.1176 8.63818 71.0802 8.63818C68.7025 8.63818 66.6709 10.4402 66.2756 12.9677C66.0699 14.2285 66.3621 15.4333 67.0768 16.2743C67.7338 17.0471 68.6709 17.3687 69.7877 17.3687C71.7045 17.3687 72.7675 16.1374 72.7675 16.1374L72.6715 16.7356C72.6354 16.963 72.8111 17.1689 73.0416 17.1689H74.9798C75.2871 17.1689 75.5487 16.9455 75.5968 16.6418L76.7602 9.27374C76.7962 9.04626 76.6204 8.84081 76.3901 8.84081Z",
    fill: "#2790C3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2326_501",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.012146 20.0816H81.7483V0.247437H0.012146V20.0816Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2326_501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.794 8.84082H53.6305C53.4236 8.84082 53.2301 8.94345 53.114 9.11456L50.1297 13.5099L48.8649 9.28627C48.7859 9.02203 48.5426 8.84082 48.2667 8.84082H46.14C45.8832 8.84082 45.7024 9.09335 45.7853 9.33638L48.1675 16.3287L45.9269 19.4903C45.7509 19.7384 45.9285 20.0816 46.2325 20.0816H48.394C48.5988 20.0816 48.7905 19.9812 48.9073 19.8127L56.102 9.4291C56.2742 9.18062 56.0964 8.84082 55.794 8.84082Z",
    fill: "#27346A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2326_501",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.012146 20.0816H81.7483V0.247437H0.012146V20.0816Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2326_501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9271 4.9993L77.0823 16.7359C77.0465 16.9633 77.2223 17.1688 77.4524 17.1688H79.3079C79.6152 17.1688 79.8768 16.9452 79.9247 16.6417L81.7437 5.11587C81.7796 4.8884 81.6039 4.68274 81.3736 4.68274H79.2972C79.1128 4.68274 78.9558 4.81708 78.9271 4.9993Z",
    fill: "#2790C3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2326_501",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 21
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.012146 20.0816H81.7483V0.247437H0.012146V20.0816Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2326_501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51558 19.2644L9.11982 15.4328L9.15881 15.2205C9.1879 15.0359 9.28245 14.867 9.42487 14.7454C9.5673 14.6237 9.74891 14.5567 9.93619 14.5567H10.416C11.2158 14.5567 11.9505 14.4712 12.6 14.3027C13.293 14.1231 13.9093 13.8433 14.4317 13.4718C14.9857 13.0779 15.4509 12.5686 15.8148 11.9585C16.1986 11.3149 16.4804 10.5399 16.6525 9.65546C16.8047 8.87445 16.8332 8.17526 16.7376 7.57708C16.6364 6.94516 16.393 6.40597 16.0142 5.97405C15.7845 5.71243 15.4905 5.48577 15.1406 5.30031L15.1323 5.29587L15.1321 5.28577C15.2544 4.50617 15.2497 3.85587 15.1182 3.29607C14.9861 2.73506 14.7186 2.23021 14.2998 1.75304C13.4321 0.764354 11.854 0.262939 9.60932 0.262939H3.44467C3.23861 0.262939 3.03861 0.336677 2.88184 0.470616C2.72507 0.604556 2.62124 0.790616 2.58891 0.994253L0.0220441 17.2716C-0.0013902 17.4201 0.0412361 17.571 0.139014 17.685C0.236792 17.7995 0.379014 17.8652 0.529317 17.8652H4.35376L4.35033 17.8833L4.0877 19.5488C4.0675 19.6783 4.10467 19.8096 4.18972 19.909C4.27477 20.0086 4.39861 20.066 4.52952 20.066H7.7372C7.9172 20.066 8.09154 20.0015 8.22831 19.8846C8.36508 19.7676 8.45598 19.6054 8.48407 19.4278L8.51558 19.2644Z",
    fill: "#27346A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2326_501",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.012146 20.0816H81.7483V0.247437H0.012146V20.0816Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2326_501)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31803 5.30703C6.35863 5.04905 6.52409 4.83794 6.74692 4.73107C6.84833 4.68259 6.96146 4.65552 7.08005 4.65552H11.9122C12.4847 4.65552 13.0184 4.69309 13.5065 4.77168C13.6459 4.7941 13.7815 4.81996 13.9134 4.84925C14.0453 4.87855 14.1732 4.91107 14.297 4.94744C14.359 4.96542 14.4198 4.98441 14.4798 5.00441C14.7194 5.084 14.9425 5.17774 15.1477 5.28643C15.3897 3.7436 15.1461 2.6937 14.3116 1.74279C13.3928 0.695921 11.733 0.247437 9.60934 0.247437H3.44469C3.01075 0.247437 2.64126 0.563194 2.57358 0.991881L0.00671414 17.2693C-0.0439929 17.5905 0.20429 17.8808 0.52934 17.8808H4.335L6.31803 5.30703Z",
    fill: "#27346A"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1477 5.28638C15.1293 5.40415 15.1089 5.52395 15.0847 5.64739C14.2719 9.82133 11.4905 11.2644 7.93819 11.2644H6.1293C5.69536 11.2644 5.32889 11.5803 5.26122 12.009L4.07233 19.5466C4.02809 19.8274 4.24526 20.0815 4.5295 20.0815H7.73738C8.11698 20.0815 8.44021 19.8054 8.4994 19.4302L8.53091 19.2672L9.13516 15.4353L9.17415 15.2235C9.23334 14.8484 9.55657 14.5722 9.93617 14.5722H10.416C13.5236 14.5722 15.957 13.3096 16.6681 9.6583C16.9651 8.13264 16.8115 6.8591 16.0259 5.96375C15.7883 5.69304 15.4925 5.469 15.1477 5.28638Z",
    fill: "#2790C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.297 4.94744C14.1731 4.91107 14.0453 4.87855 13.9134 4.84925C13.7814 4.81996 13.6459 4.7941 13.5065 4.77168C13.0184 4.69309 12.4847 4.65552 11.9121 4.65552H7.08002C6.96143 4.65552 6.8483 4.68259 6.74689 4.73107C6.52406 4.83794 6.3586 5.04905 6.318 5.30703L5.29093 11.819L5.26123 12.0091C5.32891 11.5804 5.69537 11.2644 6.12931 11.2644H7.9382C11.4905 11.2644 14.2719 9.82138 15.0847 5.64744C15.1089 5.524 15.1293 5.4042 15.1477 5.28643C14.9424 5.17774 14.7194 5.084 14.4798 5.00441C14.4198 4.98441 14.359 4.96542 14.297 4.94744Z",
    fill: "#1F264F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2326_501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 20,
    fill: "white",
    transform: "translate(0 0.081543)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaypal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paypal.e30840a76f54a627102abc32c58e8409.svg";